<template>
  <div class="global-bg">
  	<div class="fix-nav">
  		<ul class="fix-box">
  			<li class="fix-item fix-item-two">
  				<router-link to="baseInfo">
  					<span class="fix-icon person-icon"></span>
  					<span class="car-text">我的</span>
  				</router-link>
  			</li>
  			<li class="fix-item fix-item-two">

          <router-link :to="isIntegralUser ? '/score' : '/coupons'">
  					<span :class="['fix-icon', isIntegralUser ? 'integral-shop' : 'coupon']"></span>
  					<span class="car-text">{{ isIntegralUser ? '积分商城' : '优惠券' }}</span>

          </router-link>
  			</li>
      <li v-if="!isIntegralUser" class="fix-item fix-item-two">
  				<router-link to="cart">
  					<span class="fix-icon car"></span>
  					<span class="car-text">购物车</span>
  					<span class="cart-count-right">{{cartNum}}</span>
  				</router-link>
  			</li>
<!--  			<li class="fix-item fix-item-two">-->
<!--  				<a href="javascript:void(0)">-->
<!--  					<span class="fix-icon frequence"></span>-->
<!--  					<span class="car-text">收藏1</span>-->
<!--  				</a>-->
<!--  			</li>-->
<!--  			<li class="fix-item fix-item-two">-->
<!--  				<a href="javascript:void(0)" >-->
<!--  					<span class="glyphicon glyphicon-pencil"></span>-->
<!--  					<span class="car-text">客服</span>-->
<!--  				</a>-->
<!--  			</li>-->
  			<li class="fix-item left-er">
  				<span class="fix-icon code"></span>
  				<div class="global-er">
  					<a  href="#">
						<img  width="80px" height="80px" src="../assets/gzh.png"></a>
  					<div class="er-name">天正</div>
  				</div>
  			</li>
  		</ul>
  	</div>
  	<div class="top-box"  @click="toTop">
  		<em class="tab-text">返回顶部</em>
  		<span class="top-btn">
  		</span>
  	</div>
  </div>
</template>

<script>
import currentUser from '@/mixins/current-user'
import { mapGetters } from 'vuex'

export default {
  mixins: [currentUser],
name: 'fixed-right',
 data() {

 	return {
    queryParam:{},
 	}
 },
  computed: {
    ...mapGetters(['cartNum'])
  },
 mounted() {
 	 // window.addEventListener("scroll", this.handleScroll, true);
   //this.queryCartListFun()
 },
 methods: {
   // queryCartListFun() {
   //   queryCartList(this.queryParam).then(res => {
   //     console.log('购物车查询', res)
   //     // this.cartNum = res.storeCarts.length
   //   })
   // },
 	// handleScroll() {
 	//        let scrolltop = document.documentElement.scrollTop || document.body.scrollTop;
 	//       scrolltop > 30 ? (this.gotop = true) : (this.gotop = false);
 	//     },
 	    toTop() {
 	      window.scrollTo({
 	               top:0,
 	              left:0,
 	              behavior: "smooth"
 	            });
 	      // let top = document.documentElement.scrollTop || document.body.scrollTop;
 	      // // 实现滚动效果
 	      // const timeTop = setInterval(() => {
 	      //   document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
 	      //   if (top <= 0) {
 	      //     clearInterval(timeTop);
 	      //   }
 	      // }, 10);
 	    }
 },

}
</script>

<style scoped="scoped" lang="less">
	@l:#57ACA7;
	@L:@l;

	/* 右侧固定导航 */
	.global-bg {
	  width: 30px;
	  background-color: #333333;
	  /*不支持rgba的浏览器*/
	  background-color: rgba(51, 51, 51, 0.9);
	  /*支持rgba的浏览器*/
	  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#e5515151, 51, endColorstr=#e5515151, 51);
	  background: none\9;
	  height: 100%;
	  position: fixed;
	  right: 0;
	  top: 0px;
	  z-index: 1000;
	}
	.fix-nav {
	  width: 30px;
	  position: fixed;
	  right: 0;
	  top: 25%;
	  z-index: 999;
	}
	.fix-nav .left-er {
	  position: relative;
	}
	.fix-nav .left-er .global-er {
	  display: block;
	  width: 100px;
	  height: 120px;
	  background-color: @l;
	  position: absolute;
	  left: 30px;
	  bottom: 0px;
	  padding: 10px;
	  box-sizing: border-box;
	}
	.fix-nav .left-er .global-er .er-name {
	  text-align: center;
	  font-size: 12px;
	  color: #fff;
	  padding-top: 5px;
	}
	.fix-nav .fix-item {
	  width: 18px;
	  height: 18px;
	  padding: 6px;
	  cursor: pointer;
	  background-color: #333333;
	  /*不支持rgba的浏览器*/
	  background-color: rgba(51, 51, 51, 0.7);
	  /*支持rgba的浏览器*/
	  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr=#b2000000, 0, endColorstr=#b2000000, 0);
	  background: none\9;
	  margin-bottom: 1px;
	  position: relative;
	}
	.fix-nav .fix-item .fix-icon {
	  display: block;
	  height: 18px;
	}
	.fix-nav .fix-item .car {
	  background: url('../assets/company-default.png') no-repeat -223px -375px;
	}
	.fix-nav .fix-item .ear {
	  background: url('../assets/company-default.png') no-repeat -223px -416px;
	}
	.fix-nav .fix-item .code {
	  background: url('../assets/company-default.png') no-repeat -223px -462px;
	}
	.fix-nav .fix-item .phone {
	  background: url('../assets/company-default.png') no-repeat -223px -119px;
	}
	.fix-nav .fix-item .frequence {
	  background: url('../assets/company-default.png') no-repeat -223px -395px;
	}
	.fix-nav .fix-item .person-icon {
	  background: url('../assets/company-default.png') no-repeat -223px -351px;
	}
	.fix-nav .fix-item .opinion {
	  background: url('../assets/company-default.png') no-repeat -223px -439px;
	}
	.fix-nav .fix-item .coupon {
	  background: url(../assets/coupon.png) no-repeat 0 0;
	  background-size: 18px 15px;
	}
	.fix-nav .fix-item .integral-shop {
	  background: url('../assets/jfshop.png') no-repeat center;
	  background-size: 18px 18px;
	}
	.fix-nav .fix-item .cart-count-right {
	  position: absolute;
	  right: 20px;
	  top: 2px;
	  background: @l;
	  color: #fff;
	  padding: 2px 5px;
	  font-size: 12px;
	  border-radius: 50%;
	  line-height: 13px;
	}
	.fix-nav .fix-item .tab-text {
	  display: block;
	  width: 100px;
	  height: 30px;
	  line-height: 30px;
	  color: #ffffff;
	  text-align: center;
	  font-family: 微软雅黑;
	  position: absolute;
	  z-index: -1;
	  left: 40px;
	  top: 0px;
	  background-color: @l;
	  font-style: normal;
	  font-size: 12px;
	}
	.fix-nav .mgB40 {
	  margin-bottom: 40px;
	}
	.fix-nav .fix-item-two {
	  height: auto;
	  text-align: center;
	  font-size: 12px;
	}
	.fix-nav .car-text {
	  color: #fff;
	}
	.fix-nav .fix-item:hover {
	  background-color: @l;
	}
	.fix-nav .fix-item:hover .tab-text {
	  transition: left 0.3s ease-in-out 0.1s;
	  left: -100px;
	}
	.fix-nav .fix-item:hover .global-er {
	  transition: left 0.3s ease-in-out 0.1s;
	  left: -100px;
	}
	/*置顶按钮*/
	.top-box {
	  position: fixed;
	  top: 57%;
	  width: 30px;
	  padding: 6px;
	  cursor: pointer;
	  margin-bottom: 1px;
	}
	.top-box .top-btn {
	  display: block;
	  width: 18px;
	  height: 18px;
	  background: url('../assets/company-default.png') no-repeat -223px -484px;
	}
	.top-box .tab-text {
	  display: block;
	  width: 70px;
	  height: 30px;
	  line-height: 30px;
	  color: #ffffff;
	  text-align: center;
	  font-family: 微软雅黑;
	  position: absolute;
	  z-index: -1;
	  left: 40px;
	  top: 0px;
	  background-color: @l;
	  font-style: normal;
	  font-size: 12px;
	}
	.top-box:hover {
	  background-color: @l;
	}
	.top-box:hover .tab-text {
	  transition: left 0.3s ease-in-out 0.1s;
	  left: -70px;
	}
</style>
